import React, { useState, useRef, useEffect } from "react";
import "./LandingPage.scss";
import { useHistory, useLocation } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";

function Footer() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [softwareSol, setSoftwareSol] = useState(false);
  const [hardwareSol, setHardwareSol] = useState(false);
  const [email, setEmail] = useState('');
  const softwareProds = [
    { name: "PowerOptix" },
    { name: "Forecasting" },
    { name: "Fault Prediction" },
    { name: "Digital Twin" },
    { name: "Remote Management" },
    { name: "Drone Integration" },
  ];
  const hardwareProds = [
    { name: "Tracker Controller" },
    { name: "Solar Tracker" },

    { name: "SmartIQ Edge" },
  ];
  const anchorRef = useRef(null);
  const dropdownRef = useRef(null);
  const path = location.pathname;
  const handleProductClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSoftwareSol(false);
        setHardwareSol(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const isMobile = window.innerWidth <= 600;

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const subMenuClick = (ele) => {
    if (ele === "Software") {
      setSoftwareSol(true);
      setHardwareSol(false);
    } else if (ele === "Hardware") {
      setHardwareSol(true);
      setSoftwareSol(false);
    }
  };
  const history = useHistory();
  const handleHomeClick = () => {
    history.push("/");
  };
  const handleCaseStudyClick = () => {
    history.push("/case-studies");
  };

  const handleServiceClick = () => {
    history.push("/our-solution");
  };
  const handleAboutUs = () => {
    history.push("/about-us");
  };
  const handleCareers = () => {
    history.push("/careers");
  };
  const handlePolicy = () => {
    history.push("/privacypolicy");
  };
  const handleTermsConditions = () => {
    history.push("/terms_conditions");
  };
  const handleCloseFirstSubMenu = () => {
    setSoftwareSol(false);
  };
  const handleCloseSecondSubMenu = () => {
    setHardwareSol(false);
  };

  const handleSoftProdsClick = (name) => {

    if (name === "PowerOptix") {
      history.push("/products/poweroptix");
    } else if (name === "Forecasting") {
      history.push("/products/energy_forecasting");
    } else if (name === "Fault Prediction") {
      history.push("/products/fault_prediction");
    } else if (name === "Digital Twin") {
      history.push("/products/three_d_twin");
    } else if (name === "Remote Management") {
      history.push("/products/remote_management");
    } else if (name === "Drone Integration") {
      history.push("/products/drone_integration");
    }
  };
  const handleHardProdsClick = (name) => {
    if (name === "Tracker Controller") {
      history.push("/products/tracker_controller");
    } else if (name === "Solar Tracker") {
      history.push("/products/solar_tracker");
    }else if (name === "SmartIQ Edge") {
      history.push("/products/smartiq_edge");
    }
  };

  return (
    <div className="footer-sec-container">
      <div className="foo_one flex_crct">
        <div className="logo-text">
          <img
            className="footer-logo"
            src="https://s3.amazonaws.com/smarttrak.co/landing-images/smarttraklogo.svg"
            style={{ width: "13vw" }}
            alt="logo"
          />
        </div>
        {isMobile &&( <Divider 
        className="div_foo"
        style={{
          width:"100%",
          border: "0.5px solid #FFF",
        }}
      />)}
        <div className="foo_des">
          <p className="Raleway_22px" id="text_just">
            SmartTrak: Empowering businesses with intelligent solutions and
            expert guidance in AI and technology to navigate the digital
            landscape and achieve remarkable success.
          </p>
        </div>
      </div>
      {!isMobile &&( <Divider
        className="div_foo"
        style={{
          border: "0.5px solid #FFF",
        }}
      />)}

      <div className="footer-container">
        <div className="logo-text gap_1vw expert_title flex_col">
          <p className="Raleway_22px">Subscribe to our newsletter!</p>
         

<div className="email_div expert_div">
<svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        style={{ marginRight: '8px' }}
      >
        <path
          d="M19.3067 1.00679C19.3004 1.00043 19.294 0.997244 19.2876 0.990878C19.068 0.806254 18.7847 0.688477 18.4727 0.688477H1.92024C1.60829 0.688477 1.32499 0.806254 1.10217 0.994061C1.09898 0.997244 1.09262 1.00043 1.08625 1.00679C0.818864 1.23917 0.646973 1.57976 0.646973 1.96175V14.0578C0.646973 14.7613 1.21676 15.3311 1.92024 15.3311H18.4727C19.1762 15.3311 19.746 14.7613 19.746 14.0578V1.96175C19.746 1.57976 19.5741 1.24235 19.3067 1.00679ZM17.3873 1.96175L10.1965 8.12755L3.0057 1.96175H17.3873ZM1.92024 14.0578V2.70979L9.78267 9.44857C9.90045 9.55043 10.0501 9.60136 10.1965 9.60136C10.3429 9.60136 10.4925 9.55043 10.6103 9.44857L18.4727 2.70979V14.0578H1.92024Z"
          fill="black"
        />
      </svg>
          <input
            className="Raleway_17px c_black"
            value={email}
            onChange={handleEmailChange}
            type="text"
            placeholder="Enter Email address"
          />
          
        </div>

          <p className="Raleway_17px">
            Unlocking creativity across industries, including content
            generation, design, virtual avatars, and personalised storytelling,
            revolutionizing innovation and audience engagement.
          </p>
          <div className="expert_div">
          <Button
            type="submit"
            variant="contained"
            id="common-btn"
            className="submit_btn"
          >
            Submit
          </Button>
        </div>
         
        </div>
        <div
          className="nav-stuff"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "3vh",
            paddingLeft: "6vw",
          }}
        >
          <p
            onClick={handleHomeClick}
            className="Raleway_17px"
            style={{
              color: path === "/" ? "#0081FE" : "#FFF",
              cursor: path === "/" ? "none" : "pointer",
            }}
          >
            Home
          </p>
          <p
            onClick={handleCaseStudyClick}
            className="Raleway_17px"
            style={{
              color:
              path === "/case-studies" ||
              path === "/case-study/Solar-industry/solar-forecast" ||
              path === "/case-study/Solar-industry/solar-3d" ||
              path === "/case-study/Solar-industry/solar-drone" ||
              path === "/case-study/life-science" || path === "/case-study/digital-twin" ||
              path === "/case-study/manufacturing" ||
              path === "/case-study/robotics" ||
              path === "/case-study/process-industry"
                ? "#0081FE"
                : "#FFF",
              cursor: "pointer",
            }}
          >
            Case Studies
          </p>
          <div className="footer_product">
            <p
              ref={anchorRef}
              onClick={handleProductClick}
              className="Raleway_17px"
              style={{
                color:
                  path === "/products/poweroptix" ||
                  path === "/products/smartiq_edge" ||
                  path === "/products/three_d_twin" ||
                  path === "/products/energy_forecasting" ||
                  path === "/products/drone_integration" ||
                  path === "/products/fault_prediction" ||
                  path === "/products/remote_management" ||
                  path === "/products/tracker_controller"||path === "/products/solar_tracker"
                    ? "#0081FE"
                    : "#FFF",
                cursor: "pointer",
              }}
            >
              Products
            </p>
            {open && (
              <div className="footer_dropdown-pro">
                <div
                  className="footer-pro"
                  onMouseEnter={() => subMenuClick("Software")}
                  onMouseLeave={handleCloseFirstSubMenu}
                >
                  <p className="pro-elements">Software</p>
                </div>
                <div
                  className="footer-pro"
                  onMouseEnter={() => subMenuClick("Hardware")}
                  onMouseLeave={handleCloseSecondSubMenu}
                >
                  <p className="pro-elements">Hardware</p>
                </div>
              </div>
            )}
            {softwareSol && (
              <div
                ref={dropdownRef}
                className="footer_software_prods_container"
                onMouseEnter={() => setSoftwareSol(true)}
              >
                {softwareProds.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="footer_soft_prods_div"
                      onClick={() => handleSoftProdsClick(item.name)}
                    >
                      <p
                        className="Poppins_16px_rem"
                        style={{ fontWeight: "400" }}
                      >
                        {item.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
            {hardwareSol && (
              <div
                ref={dropdownRef}
                className="footer_software_prods_container"
                style={{ top: "10vh" }}
                onMouseEnter={() => setHardwareSol(true)}
              >
                {hardwareProds.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="footer_soft_prods_div"
                      onClick={() => handleHardProdsClick(item.name)}
                    >
                      <p
                        className="Poppins_16px_rem"
                        style={{ fontWeight: "400" }}
                      >
                        {item.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <p
            onClick={handleServiceClick}
            className="Raleway_17px"
            style={{
              color:
                path === "/our-solution" || /\/our-services\/[0-2]/.test(path)
                  ? "#0081FE"
                  : "#FFF",
              cursor: "pointer",
            }}
          >
            Solutions
          </p>
          <p
            onClick={handleAboutUs}
            className="Raleway_17px"
            style={{
              color: path === "/about-us" ? "#0081FE" : "#FFF",
              cursor: "pointer",
            }}
          >
            About us
          </p>
          <p
            onClick={handleCareers}
            className="Raleway_17px"
            style={{
              color: path === "/careers" ? "#0081FE" : "#FFF",
              cursor: "pointer",
            }}
          >
            Careers
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "3vh" }}>
          <p
            onClick={handlePolicy}
            style={{
              color: path === "/privacypolicy" ? "#0081FE" : "#FFF",
              cursor: "pointer",
            }}
            className="Raleway_17px"
          >
            Privacy Policy
          </p>
          <p
            className="Raleway_17px"
            onClick={handleTermsConditions}
            style={{
              color: path === "/terms_conditions" ? "#0081FE" : "#FFF",
              cursor: "pointer",
            }}
          >
            Terms & Conditions
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "3vh" }}>
          <p className="Raleway_17px" style={{fontWeight:"400"}}>
            Contact Us
          </p>
          <div className="contact-us-footer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="footer-svg"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M18.8721 16.255L16.7321 18.395C14.8231 20.304 8.70282 17.7945 5.36485 14.4565C2.02657 11.1183 -0.48291 4.99856 1.42639 3.08926L3.56636 0.949289C4.20537 0.310281 5.21727 0.363843 5.78982 1.06366L8.6282 4.53287C9.17 5.1951 9.12174 6.19795 8.51746 6.80224L7.16544 8.15425C6.99485 8.32484 6.94819 8.67852 7.06816 8.87857C7.10487 8.94834 7.13245 9.00063 7.17747 9.07952C7.25617 9.21744 7.3536 9.37474 7.47032 9.54778C7.80778 10.0481 8.22998 10.5684 8.74151 11.0799C9.25301 11.5914 9.77391 12.014 10.2753 12.3521C10.4487 12.4691 10.6064 12.5667 10.7448 12.6457C10.8239 12.6909 10.8765 12.7186 10.8986 12.7295C11.1442 12.8705 11.4987 12.8243 11.6671 12.6559L13.0191 11.3039C13.6232 10.6998 14.6268 10.6518 15.2885 11.1932L18.7577 14.0316C19.4582 14.6047 19.5117 15.6154 18.8721 16.255ZM6.26511 7.25391L7.61712 5.90191C7.75818 5.76085 7.77092 5.49583 7.64272 5.33914L4.80437 1.86992C4.70769 1.75175 4.57177 1.74456 4.4667 1.84963L2.32673 3.9896C1.12919 5.18714 3.37651 10.6675 6.26518 13.5562C9.15357 16.4446 14.6345 18.6919 15.8318 17.4947L17.9718 15.3547C18.0774 15.249 18.0703 15.1143 17.9515 15.017L14.4822 12.1787C14.326 12.0508 14.0602 12.0635 13.9195 12.2043L12.5675 13.5563C11.9962 14.1275 11.0227 14.2592 10.3194 13.8635C10.1562 13.7819 9.89547 13.6317 9.56329 13.4077C8.99686 13.0257 8.41288 12.5519 7.84117 11.9802C7.26948 11.4085 6.79612 10.8252 6.41474 10.2598C6.19269 9.93062 6.04344 9.67186 5.96171 9.50877C5.55655 8.80547 5.69133 7.82768 6.26511 7.25391Z"
                fill="#D9D9D9"
              />
            </svg>

            <p className="Raleway_17px">
              Phone:{" "}
              (+1) 510-945-8169 
            </p>
          </div>
          <div className="contact-us-footer">
            <a href="mailto:info@smarttrak.co" className="privacy_link_foo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="footer-svg"
                viewBox="0 0 20 15"
                fill="none"
              >
                <path
                  d="M19.1519 0.567341C19.1456 0.560974 19.1392 0.557791 19.1328 0.551425C18.9132 0.366801 18.6299 0.249023 18.3179 0.249023H1.76546C1.45351 0.249023 1.1702 0.366801 0.947381 0.554608C0.944198 0.557791 0.937832 0.560974 0.931465 0.567341C0.664079 0.799712 0.492188 1.14031 0.492188 1.52229V13.6183C0.492188 14.3218 1.06198 14.8916 1.76546 14.8916H18.3179C19.0214 14.8916 19.5912 14.3218 19.5912 13.6183V1.52229C19.5912 1.14031 19.4193 0.802895 19.1519 0.567341ZM17.2325 1.52229L10.0417 7.6881L2.85092 1.52229H17.2325ZM1.76546 13.6183V2.27034L9.62789 9.00911C9.74567 9.11097 9.89528 9.1619 10.0417 9.1619C10.1881 9.1619 10.3377 9.11097 10.4555 9.00911L18.3179 2.27034V13.6183H1.76546Z"
                  fill="#D9D9D9"
                />
              </svg>
            </a>
            <p className="Raleway_17px">
            Email:{" "}

              <a href="mailto:info@smarttrak.co" className="privacy_link_foo">
                {" "}
                info@smarttrak.co.
              </a>
            </p>
          </div>
          <div className="contact-us-footer">
            <div>
              <svg
                className="footer-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17 22"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.04211 4.69367C11.4406 4.69367 13.1536 8.82197 10.7483 11.2272C8.34353 13.6323 4.21476 11.9198 4.21476 8.52102C4.21476 6.40733 5.92842 4.69367 8.04211 4.69367ZM7.63506 21.4003C7.84444 21.6495 8.23041 21.653 8.444 21.4062C11.3615 18.032 16.0371 13.1999 16.0371 8.52102C16.0371 6.31318 15.142 4.31449 13.6953 2.86759C8.67118 -2.15701 0.046875 1.42091 0.046875 8.52079C0.046875 13.1981 4.71806 18.0266 7.63506 21.4003ZM7.5737 19.715C7.72781 19.8897 7.877 20.059 8.04211 20.2478C10.7687 17.131 14.9708 12.5969 14.9708 8.52079C14.9708 2.36803 7.49688 -0.732589 3.14281 3.62149C1.88888 4.87541 1.11344 6.60734 1.11344 8.52079C1.11344 12.3891 4.94805 16.7376 7.5737 19.715ZM9.99419 6.5687C8.25922 4.83396 5.28132 6.06914 5.28132 8.52079C5.28132 10.9729 8.25968 12.2074 9.99419 10.4729C11.0722 9.39483 11.0722 7.64697 9.99419 6.5687Z"
                  fill="#D9D9D9"
                />
              </svg>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1vw" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "1vw",
                  alignItems: "flex-start",
                }}
              >
                <img
                  src="https://s3.amazonaws.com/smarttrak.co/landing-images/usa.png"
                  alt="usa"
                  className="footer-social"
                />
                <p className="Raleway_17px">
                 800 Park Offices
                  Drive, Suite{" "}
                  #3510, Research
                  Triangle Park, NC{" "}
                  27709
                </p>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "1vw",
                  alignItems: "flex-start",
                }}
              >
                <img
                  src="https://s3.amazonaws.com/smarttrak.co/landing-images/india.png"
                  alt="india"
                  className="footer-social"
                />
                <p className="Raleway_17px" >
                  <span >
                    T-Hub, Hyderabad Knowledge City, Serilingampally, Hyderabad,
                    Telangana{" "}
                    500081
                  </span>
                </p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div className="foo_one flex_crct gap_1vw" id="our_sol">
            <p className="Raleway_17px">
              {" "}
              &copy; All rights Reserved to @ smarttrak.co
            </p>
            <div className="expert_title"
            style={{alignSelf:"flex-start"}} id="margin_8"
            
          >
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="23"
              viewBox="0 0 25 23"
              fill="none"
            >
              <path
                d="M14.5701 10.542L21.7701 2.04199H20.0701L13.7701 9.44199L8.67012 2.04199H2.87012L10.4701 13.142L2.87012 22.042H4.57012L11.2701 14.242L16.6701 22.042H22.4701L14.5701 10.542ZM12.1701 13.242L11.3701 12.142L5.27012 3.34199H7.97012L12.9701 10.442L13.7701 11.542L20.2701 20.742H17.5701L12.1701 13.242Z"
                fill="white"
              />
            </svg> */}
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="23"
              viewBox="0 0 25 23"
              fill="none"
            >
              <path
                d="M12.6699 1.04199C15.6699 1.04199 16.0699 1.04199 17.2699 1.04199C18.4699 1.14199 19.1699 1.34199 19.9699 1.64199C20.7699 1.94199 21.2699 2.24199 21.8699 2.94199C22.4699 3.54199 22.8699 4.24199 23.0699 4.94199C23.3699 5.64199 23.5699 6.44199 23.5699 7.64199C23.6699 8.64199 23.6699 9.04199 23.6699 12.042C23.6699 15.042 23.6699 15.442 23.5699 16.542C23.4699 17.742 23.2699 18.442 23.0699 19.242C22.8699 20.042 22.4699 20.542 21.7699 21.142C21.2699 21.742 20.5699 22.142 19.8699 22.442C19.1699 22.742 18.3699 22.942 17.1699 22.942C16.0699 23.042 15.6699 23.042 12.6699 23.042C9.66992 23.042 9.26992 23.042 8.06992 23.042C6.86992 22.942 6.16992 22.742 5.36992 22.442C4.66992 22.142 4.06992 21.842 3.46992 21.142C2.86992 20.542 2.46992 19.842 2.26992 19.142C1.96992 18.442 1.76992 17.642 1.76992 16.442C1.66992 15.442 1.66992 15.042 1.66992 12.042C1.66992 9.04199 1.66992 8.64199 1.76992 7.54199C1.76992 6.34199 1.96992 5.54199 2.26992 4.74199C2.56992 4.14199 2.86992 3.44199 3.56992 2.84199C4.26992 2.24199 4.86992 1.84199 5.46992 1.54199C6.16992 1.24199 7.06992 1.04199 8.26992 1.04199C9.26992 1.04199 9.66992 1.04199 12.6699 1.04199ZM12.6699 3.04199C9.76992 3.04199 9.36992 3.04199 8.26992 3.04199C7.16992 3.14199 6.56992 3.34199 6.16992 3.44199C5.66992 3.74199 5.36992 3.84199 4.86992 4.24199C4.46992 4.64199 4.26992 4.94199 4.06992 5.54199C3.96992 5.94199 3.76992 6.54199 3.76992 7.64199C3.66992 8.74199 3.66992 9.14199 3.66992 12.042C3.66992 14.942 3.66992 15.242 3.76992 16.442C3.76992 17.442 3.96992 18.142 4.16992 18.442C4.36992 19.042 4.66992 19.342 4.96992 19.742C5.36992 20.142 5.66992 20.342 6.26992 20.542C6.66992 20.742 7.16992 20.842 8.26992 20.942C9.36992 21.042 9.76992 21.042 12.6699 21.042C15.5699 21.042 15.8699 21.042 17.0699 20.942C18.0699 20.942 18.7699 20.742 19.0699 20.542C19.6699 20.342 19.9699 20.042 20.3699 19.742C20.7699 19.342 20.9699 19.042 21.1699 18.442C21.3699 18.042 21.4699 17.542 21.5699 16.442C21.6699 15.342 21.6699 14.942 21.6699 12.042C21.6699 9.14199 21.6699 8.84199 21.5699 7.64199C21.5699 6.64199 21.3699 6.04199 21.1699 5.64199C20.9699 5.04199 20.6699 4.74199 20.3699 4.34199C19.9699 3.94199 19.6699 3.74199 19.0699 3.54199C18.6699 3.34199 18.1699 3.24199 17.0699 3.14199C15.9699 3.04199 15.5699 3.04199 12.6699 3.04199ZM12.6699 6.34199C15.7699 6.34199 18.3699 8.94199 18.3699 12.042C18.3699 15.142 15.7699 17.742 12.6699 17.742C9.56992 17.742 6.96992 15.142 6.96992 12.042C6.96992 8.94199 9.56992 6.34199 12.6699 6.34199ZM12.6699 15.742C14.6699 15.742 16.3699 14.042 16.3699 12.042C16.3699 10.042 14.6699 8.34199 12.6699 8.34199C10.6699 8.34199 8.96992 10.042 8.96992 12.042C8.96992 14.042 10.6699 15.742 12.6699 15.742ZM18.5699 7.44199C17.8699 7.44199 17.2699 6.84199 17.2699 6.14199C17.2699 5.44199 17.8699 4.84199 18.5699 4.84199C19.2699 4.84199 19.8699 5.44199 19.8699 6.14199C19.8699 6.84199 19.2699 7.44199 18.5699 7.44199Z"
                fill="white"
              />
            </svg> */}
           
            <a
              href="https://www.linkedin.com/company/smarttrak-ai/mycompany/"
              style={{ cursor: "pointer" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="23"
                viewBox="0 0 25 23"
                fill="none"
              >
                <path
                  d="M21.1699 2.04199H4.16992C3.36992 2.04199 2.66992 2.74199 2.66992 3.54199V20.542C2.66992 21.342 3.36992 22.042 4.16992 22.042H21.1699C21.9699 22.042 22.6699 21.342 22.6699 20.542V3.54199C22.6699 2.74199 21.9699 2.04199 21.1699 2.04199ZM8.66992 19.042H5.66992V9.54199H8.66992V19.042ZM7.16992 8.24199C6.16992 8.24199 5.46992 7.54199 5.46992 6.54199C5.46992 5.54199 6.26992 4.84199 7.16992 4.84199C8.06992 4.84199 8.86992 5.54199 8.86992 6.54199C8.86992 7.54199 8.06992 8.24199 7.16992 8.24199ZM19.6699 19.042H16.6699V13.842C16.6699 12.342 15.9699 11.842 15.1699 11.842C14.2699 11.842 13.3699 12.542 13.3699 13.942V19.042H10.3699V9.54199H13.2699V10.842C13.5699 10.242 14.5699 9.24199 16.1699 9.24199C17.8699 9.24199 19.6699 10.242 19.6699 13.142V19.042Z"
                  fill="white"
                />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@SmarttrakAI"
              style={{ cursor: "pointer" }}
            >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="23"
              viewBox="0 0 25 23"
              fill="none"
            >
              <g clip-path="url(#clip0_1850_4013)">
                <path
                  d="M24.4099 7.14222C24.4099 7.14222 24.1799 5.49222 23.4599 4.77222C22.5499 3.81222 21.5299 3.81222 21.0599 3.75222C17.7099 3.51222 12.6699 3.54222 12.6699 3.54222C12.6699 3.54222 7.64992 3.51222 4.29992 3.75222C3.83992 3.81222 2.81992 3.81222 1.90992 4.77222C1.18992 5.49222 0.949922 7.14222 0.949922 7.14222C0.949922 7.14222 0.709922 9.09222 0.669922 11.0222V13.0422C0.709922 14.9822 0.949922 16.9122 0.949922 16.9122C0.949922 16.9122 1.18992 18.5622 1.90992 19.2922C2.81992 20.2422 4.00992 20.2122 4.54992 20.3122C6.42992 20.4922 12.4599 20.5322 12.6699 20.5322C12.6699 20.5322 17.7199 20.5422 21.0699 20.3022C21.5299 20.2422 22.5499 20.2422 23.4599 19.2822C24.1799 18.5622 24.4199 16.9122 24.4199 16.9122C24.4199 16.9122 24.6599 14.9722 24.6699 13.0422V11.0222C24.6499 9.09222 24.4099 7.14222 24.4099 7.14222ZM10.2399 15.5422V8.53222L16.6699 12.1722L10.2399 15.5422Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1850_4013">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.669922 0.0419922)"
                  />
                </clipPath>
              </defs>
            </svg>
            </a>

          </div>
          </div>
    </div>
  );
}

export default Footer;
